import { githubFetch } from './client';

export interface GitHubRepositoryListParams {
  target: string;
  owner: 'user' | 'org';
  visibility?: 'all' | 'public' | 'private';
  per_page?: number;
  cursor?: string;
}

export interface GitHubRepository {
  name: string;
  full_name: string;
  owner: string;
  private: boolean;
  description: string | null;
  default_branch: string;
}

export interface GitHubRepositoryListResponse {
  repositories: GitHubRepository[];
  cursor?: string;
}

export async function githubRepositoryList(
  params: GitHubRepositoryListParams
): Promise<GitHubRepositoryListResponse> {
  return githubFetch<GitHubRepositoryListResponse>('/rpc/github_repository_list', {
    body: params,
  });
}
